import { Time } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { timeToDate } from '../extensions/date.helper';

@Pipe({
    name: 'timeToDate'
})
export class TimeToDatePipe implements PipeTransform{
    transform(value: Time, useUtc: boolean = false) {
        return timeToDate(value, useUtc);
    }

}